import Hero from "./components/Hero";
import Team from "./components/Team";
import LocationHours from "./components/LocationHours";
import Footer from "./components/Footer";
import Philosophy from "./components/Philosophy";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import Brands from "./components/Brands";
import Gradient from "./components/Gradient";
import ScrollToTopArrow from "./components/ScrollToTopArrow";
import PhotoGallery from "./components/PhotoGallery";

function App() {
	return (
		<div className="overflow-hidden">
			<Hero />
			<Philosophy />
			<Services />
			<Gradient color1="#dedad5" color2="#ffffff" />
			<Team />
			<Gradient color1="#ffffff" color2="#dedad5" />
			<PhotoGallery />
			<Brands />
			<Testimonials />
			<Gradient color1="#dedad5" color2="#ffffff" />
			<LocationHours />
			<Footer />
			<ScrollToTopArrow />
		</div>
	);
}

export default App;
